<template>
  <div class="all">
    <div class="header">
      <h1>BLOG<br>部落格</h1>
    </div>
    <section id="section1" class="section1">
      <div class="custom-container">
        <div class="row custom-row">
          <div class="custom-grid col-md-4 col-sm-6" v-for="card in blog_data">
            <router-link :to="{name: 'Blog-detail',params: { id: card.slug }}">
              <div class="blog-card">
                <div class="card-img" :style="{'background-image': 'url(' + card.trans.image_path + ')'}"></div>
                <div class="card-content">
                  <h2 class="title">{{card.trans.name}}</h2>
                  <h6 class="date">{{formatDate(card.publish_start)}}</h6>
                  <p class="description">{{formatContent(card.trans.editors[0].content)}}</p>
                  <div class="more">More ></div>
                </div>
              </div>
            </router-link>
          </div>
        </div>
        <!-- 分頁 -->
        <div class="pagination-wrap">
          <paginate
            :page-count="page_count"
            :page-range="3"
            :margin-pages="1"
            :click-handler="clickCallback"
            :prev-text="'<'"
            :next-text="'>'"
            :value="parseInt(now_page)"
            :container-class="'blog-pagination'"
            :page-class="'page-item'"
            :next-class="'page-item'"
            :prev-class="'page-item'"
            v-scroll-to="'#app'"
            v-if="page_count > 1"
          >
          </paginate>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
  import navigation from './navigation.vue';
  export default {
  name: 'Blog',
    components:{
      navigation
    },
    data() {
      return {
        //目前頁數
        now_page: 1,
        //總頁數
        page_count:1,
        blog_data:[],
      }
    },
    methods:{
      clickCallback: function(page){
        let vm = this;
        vm.now_page = page
        vm.$router.push({
          name: 'Blog',
          params: {
            pageNum: vm.now_page
          }
        })
        vm.CallBlogApi();
      },
      CallBlogApi(){
        let vm = this;
        vm.axios({
          method: "get",
          url: process.env.VUE_API_URL + "v1/article/blog",
          params:{
            limit:6,
            page:vm.$route.params.pageNum
          }
        })
        .then(function (response) {
          console.log(response)
          let res = response.data.data.results;
          let total = response.data.data.total
          vm.blog_data = res;
          vm.page_count = Math.ceil(total / 6)
        })
        .catch(function (error) {
          console.log(error)
        })
      },
      formatDate(date) {
        let formatted = new Date(date);
        let year = formatted.getFullYear().toString();
        let month = (formatted.getMonth() + 1).toString();
        let addzero = ("0" + month).slice(-2)
        let day = formatted.getDate().toString();
        return `${year}-${addzero}-${day}`;
      },
      formatContent(content) {
        let div = document.createElement('div');
        div.innerHTML = content;
        let result = div.textContent || div.innerText || '';
        return result;
      }
    },
    mounted(){
      this.now_page = this.$route.params.pageNum;
      this.CallBlogApi();
    }
  }
</script>

<style lang="scss">
  .pagination-wrap{
    display: flex;
    justify-content: center;
    .blog-pagination{
      display: inline-flex;
      justify-content: center;
      margin-top: 90px;
      .page-item{
        width: 43px;
        height: 43px;
        line-height: 43px;
        border-radius: 50%;
        color: white;
        background-color: transparent;
        border: none;
        text-align: center;
        @media screen and (max-width:768px){
          width: 36px;
          height: 36px;
          line-height: 36px;
        }
        a{
          display: inline-block;
          width: 100%;
          height: 100%;
          color:black;
          &:focus{
            outline:none;
          }
        }
        &.active{
          background-color: black;
          a{
            color: white;
          }
        }
      }
    }
  }
  
</style>

<style lang="scss" scoped>
  @import 'src/assets/scss/blog/header.scss';
  @import 'src/assets/scss/blog/section1.scss';
</style>


// WEBPACK FOOTER //
// src/components/Blog.vue